import React from "react";
import "./Main.css";
import { render } from 'react-dom';
import Typed from 'react-typed';
import 'react-typed/dist/animatedCursor.css';
import ReactTooltip from 'react-tooltip';

class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        return (
            <div className="main">
                <div className="container">
                    <div className="main_main">
                        <img className="main_gradient" src="img/main_gradient.png" />
                        <div className="main_left">
                            <img src="img/nut.svg" />
                            <h6>Smart Wallet</h6>
                            <h1>One Tap<br /> <Typed
                                strings={[
                                    'NFT',
                                    'DEFI',
                                    'CRYPTO',
                                    'BLOCKCHAIN']}
                                typeSpeed={40}
                                backSpeed={50}
                                backDelay={3000}
                                showCursor={true}
                                cursorChar={'▋'}
                                loop >

                            </Typed>Access</h1>
                            {/* <h1 className="mobile_h1">One-Tap DEFI ACCESS.</h1> */}
                            <p>Non-custodial blockchain wallet for Decentralized Finance (DeFi) and Non-Fungible Tokens (NFTs)
                            </p>
                            <ReactTooltip />
                            <a data-tip="Coming Soon" data-class="main_tooltip" data-type="light" className="button">
                                Learn More
                            </a>
                            <a className="scroll"><svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.75 17.5V25.1562C8.75 27.4769 9.67187 29.7025 11.3128 31.3434C12.9538 32.9844 15.1794 33.9062 17.5 33.9062C19.8206 33.9062 22.0462 32.9844 23.6872 31.3434C25.3281 29.7025 26.25 27.4769 26.25 25.1562V17.5C26.25 15.1794 25.3281 12.9538 23.6872 11.3128C22.0462 9.67187 19.8206 8.75 17.5 8.75C15.1794 8.75 12.9538 9.67187 11.3128 11.3128C9.67187 12.9538 8.75 15.1794 8.75 17.5V17.5ZM17.5 15.8594C17.7163 15.8594 17.9278 15.9235 18.1077 16.0437C18.2875 16.1639 18.4277 16.3347 18.5105 16.5346C18.5933 16.7344 18.6149 16.9543 18.5727 17.1665C18.5305 17.3787 18.4264 17.5736 18.2734 17.7265C18.1204 17.8795 17.9255 17.9837 17.7134 18.0259C17.5012 18.0681 17.2813 18.0464 17.0814 17.9636C16.8816 17.8808 16.7108 17.7406 16.5906 17.5608C16.4704 17.3809 16.4062 17.1694 16.4062 16.9531C16.4062 16.663 16.5215 16.3848 16.7266 16.1797C16.9317 15.9746 17.2099 15.8594 17.5 15.8594V15.8594ZM16.9531 9.87164V14.8433C16.4376 14.9764 15.9883 15.2929 15.6895 15.7336C15.3907 16.1743 15.2628 16.7088 15.3299 17.237C15.397 17.7651 15.6544 18.2507 16.0539 18.6027C16.4534 18.9546 16.9676 19.1488 17.5 19.1488C18.0324 19.1488 18.5466 18.9546 18.9461 18.6027C19.3456 18.2507 19.603 17.7651 19.6701 17.237C19.7372 16.7088 19.6093 16.1743 19.3105 15.7336C19.0117 15.2929 18.5624 14.9764 18.0469 14.8433V9.87164C19.9761 10.0107 21.7812 10.8744 23.0999 12.2894C24.4186 13.7044 25.1532 15.5658 25.1562 17.5V25.1562C25.1562 27.1868 24.3496 29.1342 22.9138 30.57C21.478 32.0059 19.5306 32.8125 17.5 32.8125C15.4694 32.8125 13.522 32.0059 12.0862 30.57C10.6504 29.1342 9.84375 27.1868 9.84375 25.1562V17.5C9.84675 15.5658 10.5814 13.7044 11.9001 12.2894C13.2188 10.8744 15.0239 10.0107 16.9531 9.87164V9.87164Z" fill="black" />
                            </svg>Scroll Down
                            </a>
                        </div>
                        <div className="main_right">
                            <img src="img/phone.png" className="phone" />
                            <div className="sguirell_wrapper">
                                <img src="img/squirell.gif" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Main;
